import { queryString } from '../utils/url.js';

function SearchToolbarDropdownController (redirectPath, objectParams, callbackFn) {
    // Show/Hide dropdown options related to 'current session state'

    let stateDropDownsMenu = window.state === 'CAMPINAS' ? 'SP' : window.state;
    toggleDropdowns(stateDropDownsMenu);

    const menuBlockState = document.getElementById('search-menu-block-state');
    if(menuBlockState){
        menuBlockState.addEventListener('change', (event) => {
            const stateValue = event.currentTarget.value;

            // Reset regions dropdown value
            document.getElementById('search-menu-block-regions-sp').value = '';
            document.getElementById('search-menu-block-regions-rj').value = '';
            document.getElementById('search-menu-block-type-sp').value    = '';
            document.getElementById('search-menu-block-type-rj').value    = '';
            objectParams.data.regions = '';
            objectParams.data.type    = '';

            // Show/Hide dropdown options related to 'selected state'
            toggleDropdowns(stateValue);
        });

        new DropdownController(redirectPath, objectParams);
    }
}

function DropdownController(redirectPath, objectParams, callbackFn) {
    Object.keys(objectParams.data).map(key => {
        regionDropdownSelection(
            objectParams.dropdownIds[key],
            objectParams.data,
            key
        ).addEventListener('dropdown_updated', (e) => {
            if(callbackFn) callbackFn(e.detail);
        });
    });

    const buttonEl = document.getElementById(objectParams.buttonId);
    buttonEl.addEventListener('click', function(e) {
        e.preventDefault();
        
        const { state, regions, type } = objectParams.data;
        let url = `${redirectPath}?${queryString(objectParams.data)}`;

        // console.log('URL ->', url);
        // if(state == '' || regions == '' || type == '') return;
        
        if (
            this.id === 'see-more-button' && regions === '' ||
            this.id === 'slider-find-button' && regions === '')
        {
            window.location = url.split('?')[0];
        } else {
            window.location = url;
        }
    });
}

function regionDropdownSelection(dropdownSelector, objectParams, key) {
    const dropdownEl = document.getElementById(dropdownSelector);

    // console.log('Element Dropdown : ', dropdownEl);

    objectParams[key] = dropdownEl.value;

    dropdownEl.addEventListener('change', function (e) {
        // console.log('Dropdown Change :: ', e.currentTarget.value);
        objectParams[key] = e.currentTarget.value;
        e.currentTarget.dispatchEvent(new CustomEvent("dropdown_updated", {detail: objectParams}));
    });

    return dropdownEl;
}

function toggleDropdowns(stateValue) {
    toggleVisibleOptions('SP', stateValue);
    toggleVisibleOptions('RJ', stateValue);
}

function toggleVisibleOptions(stateString, stateSelected) {
    Array.prototype.slice
        .call(document.querySelectorAll('[data-state="'+ stateString +'"]'))
        .map(item => item.style.display = stateSelected == stateString ? 'block' : 'none');
}

export { DropdownController, SearchToolbarDropdownController };
